import { EmptyState } from '@components/molecules/empty-state';
import {
  dateFormat,
  defaultParams,
  pageSizeOptions,
  showSizeChanger,
  dateTimeFormat,
} from '@utils/constants';
import { ICustomer } from '@interfaces/icustomer';
import { IMeta } from '@interfaces/imeta';
import { IPurchaseOrder } from '@interfaces/ipurchase-order';
import { companyTypeCase, orderStatusCase } from '@utils/string-case';
import { filter, tableChangeParams } from '@utils/table';
import { formatTime } from '@utils/time';
import { Table } from 'antd';
import { PaginationConfig } from 'antd/lib/table';
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

interface IProps {
  isFetching: boolean;
  fetchDataSource: (params: any) => void;
  dataSource?: any;
  meta: IMeta;
}

interface IState {
  tableParams: any;
}

export class TableComponent extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      tableParams: defaultParams,
    };
  }
  public componentDidMount = () => {
    const { fetchDataSource } = this.props;
    const { tableParams } = this.state;
    fetchDataSource(tableParams);
  };
  public onChangeTable = (pagination: PaginationConfig, filters: any, sorter: any) => {
    const { fetchDataSource } = this.props;
    const { tableParams } = this.state;

    const params = tableChangeParams(pagination, filters, sorter, tableParams);
    this.setState({ tableParams: params });
    fetchDataSource(params);
  };
  public render() {
    const { dataSource, isFetching, meta } = this.props;
    const tableEmptyState = <EmptyState emptyText="Data Tidak Ditemukan" />;
    const columns: any = [
      {
        title: 'Nomor PO',
        dataIndex: 'code',
        ...filter('code'),
        sorter: true,
        render: (text: any, record: IPurchaseOrder) => (
          <Link to={`/purchase-order/detail/${record.code}`}>{text}</Link>
        ),
        fixed: 'left',
        width: 150,
      },
      {
        title: 'Customer',
        dataIndex: 'customer',
        ...filter('customer'),
        render: (record: ICustomer) => (
          <Link to={`/customer/detail/${record.code}`}>
            {companyTypeCase(record.type, record.name)}
          </Link>
        ),
        width: 180,
      },
      {
        title: 'No SM',
        dataIndex: 'smCode',
        ...filter('smCode'),
        sorter: true,
        render: (text: string) =>
          text ? <Link to={`/surat-muatan/detail/${text}`}>{text}</Link> : '-',
        width: 120,
      },
      {
        title: 'No DM',
        dataIndex: 'dmCode',
        ...filter('dmCode'),
        sorter: true,
        render: (text: string) =>
          text ? <Link to={`/daftar-muatan/detail/${text}`}>{text}</Link> : '-',
        width: 120,
      },
      {
        title: 'Tanggal Muat',
        dataIndex: 'orderDate',
        ...filter('orderDate'),
        sorter: true,
        render: (text: any) => (text ? formatTime(text, dateFormat) : '-'),
      },
      {
        title: 'Pick Up',
        dataIndex: 'pickupAddress',
        ...filter('pickupAddress'),
        render: (text: any) => text || '-',
        ellipsis: true,
      },
      {
        title: 'Tujuan',
        dataIndex: 'destinationAddress',
        ...filter('destinationAddress'),
        sorter: true,
        render: (text: any) => text || '-',
        ellipsis: true,
      },
      {
        title: 'Status',
        dataIndex: 'status',
        ...filter('status'),
        sorter: true,
        render: (text: number) => orderStatusCase(text),
      },
      {
        title: 'Diupdate Oleh',
        dataIndex: 'updated_by',
        ...filter('updated_by'),
        sorter: true,
        render: (text: string) => text || '-',
        width: 200,
      },
      {
        title: 'Diupdate Pada',
        dataIndex: 'updated_at',
        ...filter('updated_at'),
        sorter: true,
        render: (text: any) => (text ? formatTime(text, dateTimeFormat) : '-'),
        width: 200,
      },
      {
        title: 'Action',
        render: (text: any, record: IPurchaseOrder) => (
          <Fragment>
            <Link to={`/purchase-order/form/${record.code}`}>Ubah</Link>
            {/* <Divider type="vertical" />
            <Button type="link">Hapus</Button> */}
          </Fragment>
        ),
        width: 200,
      },
    ];

    return (
      <div className="bt-table">
        <Table
          size="small"
          onChange={this.onChangeTable}
          columns={columns}
          dataSource={dataSource}
          bordered={true}
          pagination={
            meta && {
              current: meta.current_page,
              pageSize: meta.per_page,
              pageSizeOptions,
              showSizeChanger,
              total: meta.total,
            }
          }
          locale={{
            emptyText: tableEmptyState,
          }}
          loading={isFetching}
          scroll={{ x: 1800 }}
          rowKey="id"
        />
      </div>
    );
  }
}

export default TableComponent;
